export enum ScimProviderType {
  Default = 0,
  AzureAd = 1,
  Okta = 2,
  OneLogin = 3,
  JumpCloud = 4,
  GoogleWorkspace = 5,
  Rippling = 6,
}
